import React, { Component } from 'react';
import { Galleria } from 'primereact/galleria';
import { Button } from 'primereact/button';
import { Slider } from 'primereact/slider';
import { ServiceApi } from "./../../service/Api";
import { ServiceMessage } from "../../service/Message";
import axios from "axios";
import md5 from 'md5';
import { ProgressSpinner } from 'primereact/progressspinner';
import print from 'print-js';
import sun from '../../images/sun.svg';
import { v4 as uuidv4 } from 'uuid';
import { GaleriaServices } from '../../service/GaleriaServices';
import { BuscarImagensLista, listarJob, PrintJobId, GetProgress } from "../../service/ServiceJob"; 


let listaImgThumb = [];
let _listaImagens = [];
var xhr = null;

export class GaleriaImagens extends Component {

    constructor(props) {
        super();
        this.state = {
            // ...existing state...
            splash: false,
            listaSeries: [],
            intances: [],
            listaImagensThumb: [],
            listaImagens: [],
            selectImageView: "",
            visible: false,
            autoHeigth: "auto",
            activeIndex: 0,
            _autoWidth: window.innerWidth,
            _autoHeigth: window.innerHeight,
            valueInputThumb: 1,
            brilhoImageValue: 500,
            totalImagens: 0,
            impressaoImagens: "",
            servicoDeImagem: "asl.dicom",
            abortaRequisicao: false,
            footerVisible: true,
            carregandoFrames: false,
            carregandoThumbs: true,
            // JOBS
            possuiJob: false,
            exibindoJobs: false,
            listaJobs: [],
            jobSelecionado: null,
            jobImages: [],
            carregandoJobs: false,
            progressoJob: 0,
        };

        this.serviceImages = "";
        this.compare = "";
        this.iconPanel = "pi pi-window-maximize";
        this.iconTitle = "Visualizar em tela cheia";
        this.ultimaImagemArrastada = null;

        this.thumbnailTemplate = this.thumbnailTemplate.bind(this);

        this.responsiveOptions = [
            {
                breakpoint: '1024px',
                numVisible: 5
            },
            {
                breakpoint: '768px',
                numVisible: 3
            },
            {
                breakpoint: '560px',
                numVisible: 1
            }
        ];

    }


    funcaoArrastarSoltarImagem() {
        let _listaImagensThumb = document.getElementById("listaImagensThumb");
        var touchPos;

        if (this.props.mobilecheck()) {

            function borderDragOverMob(ativar) {
                try {
                    const el = document.body.getElementsByClassName('p-galleria-item')[0];
                    try {
                        ativar ? el.classList.add('dragBorderOver') : el.classList.remove('dragBorderOver');
                    } catch (error) { }
                } catch (error) { console.log(error); }
            }

            _listaImagensThumb.addEventListener('touchmove', function (e) {
                touchPos = e.targetTouches[0].clientX;
                borderDragOverMob(touchPos > 250);
            }, { passive: true });

            _listaImagensThumb.addEventListener('touchend', function (e) {
                if (touchPos > 250) {
                    if (e.target.tagName === "IMG") {
                        document.getElementById(e.target.id).click();
                        borderDragOverMob(false);
                    }
                }
            });
        } else {

            function borderDragOverWeb(ativar) {
                const el = document.body.getElementsByClassName('p-galleria-item')[0];
                try {
                    ativar ? el.classList.add('dragBorderOver') : el.classList.remove('dragBorderOver');
                    el.addEventListener('dragover', function (e) {
                        e.preventDefault();
                    });
                } catch (error) { }
            }

            try {
                _listaImagensThumb.addEventListener("dragover", function (e) {
                    borderDragOverWeb(e.clientX > 170 && e.clientY < 555);
                }, { passive: true });
            } catch (ex) { }

            try {
                _listaImagensThumb.addEventListener("dragend", function (e) {
                    e.preventDefault();
                    try {
                        if (e.clientX > 170 && e.clientY < 555)
                            document.getElementById(e.target.id).click();
                    } catch (error) { }
                    borderDragOverWeb(false);
                });
            } catch (ex) { }

        }
    }

    thumbMouseMove() {

        const el = document.body.getElementsByClassName('p-galleria-item')[0];

        function borderDragOverWeb(ativar) {
            try {
                try {
                    ativar ? el.classList.add('dragBorderOver') : el.classList.remove('dragBorderOver');
                } catch (error) { }
            } catch (error) { }
        }

        try {
            const slider = document.querySelector('.itemsThumb');
            let isDown = false;
            let startX;
            let scrollLeft;
            slider.addEventListener('mousedown', (e) => {
                isDown = true;
                slider.classList.add('active');
                startX = e.pageX - slider.offsetLeft;
                scrollLeft = slider.scrollLeft;
            });
            slider.addEventListener('mouseleave', () => {
                isDown = false;
                slider.classList.remove('active');
            });
            slider.addEventListener('mouseup', (e) => {
                isDown = false;
                slider.classList.remove('active');
            });
            slider.addEventListener('mousemove', (e) => {
                if (!isDown) return;
                e.preventDefault();
                const x = e.pageX - slider.offsetLeft;
                const walk = (x - startX) * 3; //scroll-fast
                slider.scrollLeft = scrollLeft - walk;
            });

            //Arrastar/soltar imagem...                    
            el.addEventListener("dragover", function (e) {
                e.preventDefault();
                borderDragOverWeb(e.clientX > 200 && e.clientY < 570);
            });

            slider.addEventListener("dragend", function (e) {
                e.preventDefault();
                if (e.clientX > 200 && e.clientY < 570)
                    document.getElementById(e.target.id).click();
                borderDragOverWeb(false);
            });
        }
        catch (error) { console.log(error); }

        if (this.props.mobilecheck()) {
            let touchPos = { StartX: 0, EndX: 0, StartY: 0, EndY: 0 };
            el.addEventListener('touchmove', function (e) {
                if (touchPos.StartX === 0 && touchPos.StartY === 0) {
                    touchPos.StartX = e.targetTouches[0].clientX;
                    touchPos.StartY = e.targetTouches[0].clientY;
                }
                touchPos.EndX = e.targetTouches[0].clientX;
                touchPos.EndY = e.targetTouches[0].clientY;
            }, { passive: true });
            el.addEventListener('touchend', function (e) {
                if (touchPos.StartX > 0 && touchPos.EndX > 0) {
                    if (touchPos.EndY < (touchPos.StartY * 2) && touchPos.EndY > (touchPos.StartY / 2))
                        touchPos.StartX > touchPos.EndX ? window.nextImageTouch() : window.prevImageTouch();
                    touchPos = { StartX: 0, EndX: 0, StartY: 0, EndY: 0 }
                }
            });
        }
    }

    checkServicoDeImagem() {
        const servicoImagem = this.props.servicoImagem;
        try {
            if (servicoImagem.split("/studies").length > 1) {
                return this.setState({
                    servicoDeImagem: "asl.dicom"
                })
            }
        } catch (error) { }
    }

    async componentDidMount() {
        this.checkServicoDeImagem();
        document.getElementById("progressSpinner").style.display = "flex";
        document.body.style.overflow = 'hidden';
        window.addEventListener("resize", this.atualizarWidthHeigth, false);
        setTimeout(() => {
            this.funcaoArrastarSoltarImagem();
        }, 1000);
        window.prevImageTouch = () => { this.prevImageTouch() };
        window.nextImageTouch = () => { this.nextImageTouch() };
        await this.init(); // ALTERADO PARA AGUARDAR INIT
    }

    prevImageTouch() {
        let _activeIndex = this.state.activeIndex > 0 ? this.state.activeIndex - 1 : 0;
        this.setState({
            activeIndex: _activeIndex,
            valueInputThumb: _activeIndex + 1
        });
    }
    nextImageTouch() {
        let _activeIndex = this.state.activeIndex + 1 < this.state.listaImagens.length ? this.state.activeIndex + 1 : this.state.activeIndex;
        this.setState({
            activeIndex: _activeIndex,
            valueInputThumb: _activeIndex + 1
        });
    }

    atualizarWidthHeigth = (event) => {
        this.setState({
            _autoHeigth: event.target.innerHeight,
            _autoWidth: event.target.innerWidth,
        })
        setTimeout(() => {
            this.funcaoArrastarSoltarImagem();
        }, 1000);
    }

    componentWillUnmount() {
        // Reset total do scroll da p�gina ao sair da galeria
        document.body.style.overflow = 'auto';
        document.body.classList.remove('p-overflow-hidden', 'overflow-hidden');

        document.documentElement.style.overflow = 'auto';
        document.documentElement.classList.remove('p-overflow-hidden', 'overflow-hidden');
    }

    async componentDidUpdate(prevProps) {
        if (this.props.selectedPedido !== prevProps.selectedPedido) {
            await this.init();
        }
    }

async init() {
        if (this.props.selectedPedido) {
            window.hasJob = false;
            this.setState({ carregandoJobs: true });
            try {
                if (this.props.selectedPedido.AcNumber){

                const jobs = await listarJob(this.props.selectedPedido.AcNumber);
                if (jobs != false && Array.isArray(jobs) && jobs.length > 0) {
                    window.hasJob = true;
                    // Busca thumbs dos jobs
                    const thumbs = await Promise.all(jobs.map(async job => {
                        const imgs = await BuscarImagensLista(job.Id);
                        return {
                            ...job,
                            thumb: imgs[0]?.ImageBase64 || null,
                            images: imgs
                        };
                    }));
                    this.setState({
                        possuiJob: true,
                        exibindoJobs: true,
                        listaJobs: thumbs,
                        jobSelecionado: thumbs[0],
                        jobImages: thumbs[0].images,
                        carregandoJobs: false,
                        activeIndex: 0,
                        valueInputThumb: 1,
                        listaImagensThumb: [],
                        listaImagens: [],
                        selectImageView: "",
                    });
                    const doc = document.getElementById("progressSpinner");
                    if(doc){
                        doc.style.display = "none";
                    }
                    return;
                }
            }

            } catch (e) {
                console.log(e);
                // Se erro, segue fluxo normal
            }

            // Se não tem job, fluxo normal
            this.setState({
                possuiJob: false,
                exibindoJobs: false,
                listaJobs: [],
                jobSelecionado: null,
                jobImages: [],
                carregandoJobs: false,
            });
            let _compare = btoa(this.props.selectedPedido.Series);
            if (this.compare !== _compare) {
                this.setState({
                    listaImagensThumb: [],
                    listaImagens: [],
                    selectImageView: "",
                    carregandoThumbs: true
                });
                this.listarSeries();
                this.compare = _compare;
            }
        }
    }

        alternarVisualizacao = () => {
        this.setState((prev) => ({
            exibindoJobs: !prev.exibindoJobs
        }));
    };

    selecionarJob = (job) => {
        this.setState({
            jobSelecionado: job,
            jobImages: job.images,
            exibindoJobs: true,
            activeIndex: 0,
            valueInputThumb: 1
        });
    };

    selecionaPrimeiraImagem() {
        setTimeout(() => {
            try {
                document.getElementById("img0").click();
                document.getElementById("progressSpinner").style.display = "none";
            } catch (error) {

            }
        }, 2000);
    }

    downloadDicomFilesCompleted(servicoImagem, studyUid, seriesAslDicom) {
        const tm = setInterval(async () => {
            await axios.get(`${servicoImagem}/${studyUid}/DownloadDicomFilesCompleted`)
                .then(async res => {
                    if (res.data) {
                        this.adicionaImagensAListaAslDicom(seriesAslDicom);
                        clearInterval(tm);
                    }
                })
                .catch(error => {
                    console.log(error);
                    clearInterval(tm);
                    this.adicionaImagensAListaAslDicom(seriesAslDicom);
                });
        }, 1000);
    }

    checarImagensS3(servicoImagem, studyUid, seriesAslDicom) {
        axios.get(`${servicoImagem}/${studyUid}/isS3`)
            .then(res => {
                if (res.data) {
                    this.downloadDicomFilesCompleted(servicoImagem, studyUid, seriesAslDicom);
                    return;
                }
                this.checarImagensS3(servicoImagem, studyUid, seriesAslDicom);
            })
            .catch(error => {
                console.log(error);
                return this.adicionaImagensAListaAslDicom(seriesAslDicom);
            });
    }

    adicionaImagensAListaAslDicom(seriesAslDicom) {
        listaImgThumb = [];
        let order = 0;
        try {
            if (seriesAslDicom.length > 0) {

                seriesAslDicom.forEach(obj => {
                    let urlImage = `${this.props.servicoImagem}/${this.props.selectedPedido.StudyUid}/series/${obj.Serie}/instances/${obj.Instances[0]}/frames/0/rendered/512/512`;
                    order++;
                    this.loadFileSerie(urlImage, obj, order);
                });

                const tm = setInterval(() => {
                    if (order === listaImgThumb.length) {
                        clearInterval(tm);
                        const listaImgThumbOrdenada = listaImgThumb.sort((a, b) => {
                            if (a.order < b.order)
                                return -1;
                            if (a.order > b.order)
                                return 1;
                            return 0;
                        });

                        this.setState({
                            listaImagensThumb: listaImgThumbOrdenada,
                            selectImageView: listaImgThumbOrdenada[0]?.label,
                            carregandoThumbs: false
                        });

                        this.selecionaPrimeiraImagem();
                    }
                }, 200);

                document.getElementById("progressSpinner").style.display = "none";
            } else {
                // Nenhuma série/imagem encontrada
                this.setState({ carregandoThumbs: false });
                document.getElementById("progressSpinner").style.display = "none";
            }
        } catch (error) {
            console.log(error);
            this.setState({ carregandoThumbs: false });
            try { document.getElementById("progressSpinner").style.display = "none"; } catch (e) {}
        }

    }

    listarSeriesServicoAsl() {
        const galeriaServices = new GaleriaServices();

        galeriaServices.getValuesServiceSerie(this.props.servicoImagem, this.props.selectedPedido.StudyUid)
            .then(response => {
                this.adicionaImagensAListaAslDicom(response);
            })
            .catch(error => { 
                console.log(error);
                this.setState({ carregandoThumbs: false });
                try { document.getElementById("progressSpinner").style.display = "none"; } catch (e) {}
            })
    }

    listarSeriesServicoOrthanc() {
        try {
            if (this.props.selectedPedido) {
                let series = [];
                try {
                    series = JSON.parse(this.props.selectedPedido.Series) || [];
                } catch (e) {
                    series = [];
                }

                if (!Array.isArray(series) || series.length === 0) {
                    this.setState({ carregandoThumbs: false });
                    try { document.getElementById("progressSpinner").style.display = "none"; } catch (e) {}
                    return;
                }

                const requests = series.map(el => {
                    let url = this.props.servicoImagem + "/series/" + el.Id;
                    return ServiceApi.getImages(url)
                        .then(res => {
                            if (res && res.Instances) this.adicionaImagensALista(res.Instances);
                        })
                        .catch(err => {
                            console.log(err);
                            return null;
                        });
                });

                Promise.all(requests)
                    .then(() => {
                        this.setState({ carregandoThumbs: false });
                        if (listaImgThumb.length > 0) {
                            this.selecionaPrimeiraImagem();
                        } else {
                            try { document.getElementById("progressSpinner").style.display = "none"; } catch (e) {}
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        this.setState({ carregandoThumbs: false });
                        try { document.getElementById("progressSpinner").style.display = "none"; } catch (e) {}
                    });
            } else {
                this.setState({ carregandoThumbs: false });
                try { document.getElementById("progressSpinner").style.display = "none"; } catch (e) {}
            }
        } catch (error) {
            console.log(error);
            this.setState({ carregandoThumbs: false });
            try { document.getElementById("progressSpinner").style.display = "none"; } catch (e) {}
        }
    }

    adicionaImagensALista(instances) {
        let urlImage = this.props.servicoImagem + "/instances/" + instances[0] + "/rendered?height=512";
        this.loadFileSerie(urlImage, instances);
    }

    listarSeries() {
        // Inicia indicador de carregamento das thumbs/séries
        this.setState({ carregandoThumbs: true });
        if (this.state.servicoDeImagem === "asl.dicom")
            return this.listarSeriesServicoAsl();
        return this.listarSeriesServicoOrthanc();
    }

    loadFileSerie(urlImage, instances, order) {
        document.getElementById("progressSpinner").style.display = "flex";
        axios.get(urlImage, {
            responseType: 'arraybuffer',
            headers: {
                'Accept': 'image/jpeg',
                'height': '512',
                'smooth': true
            }
        }).then(response => {
            const _blob = new Blob([response.data], { type: 'image/jpeg' });
            listaImgThumb.push({ label: URL.createObjectURL(_blob), instances: instances, order: order });
        });
    }

    loadFileGaleria(urlImage, order, serie, instance) {
        document.getElementById("progressSpinner").style.display = "flex";
        axios.get(urlImage, {
            responseType: 'arraybuffer',
            headers: {
                'Accept': 'image/jpeg',
                'height': '512',
                'smooth': true
            }
        }).then(response => {
            const existSerie = _listaImagens.find(obj => obj.Serie === serie);
            _listaImagens = this.state.listaImagens;
            if (!existSerie)
                _listaImagens = [];
            const existInstance = _listaImagens.find(obj => obj.Instance === instance);
            if (!existInstance) {
                const _blob = new Blob([response.data], { type: 'image/jpeg' });
                _listaImagens.push({ label: URL.createObjectURL(_blob), order: order, Serie: serie, Instance: instance });
                this.setState({
                    listaImagens: _listaImagens,
                    selectImageView: _listaImagens[0].label
                });
            }
        });
    }

    async getNumeroDeFramesFromMetadata(studyUID, seriesUID, instanceUID) {
        try {
            const url = `${this.props.servicoImagem}/${studyUID}/series/${seriesUID}/instances/${instanceUID}/metadata`;
            const response = await axios.get(url, {
                headers: { Accept: "application/dicom+json" }
            });

            const metadata = Array.isArray(response.data) ? response.data[0] : response.data;
            const numFrames = metadata?.["00280008"]?.Value?.[0] || 1;

            return parseInt(numFrames);
        } catch (err) {
            console.error("Erro ao obter metadados DICOM:", err);
            return 1;
        }
    }

    async listarImagensPorSerie(instances, indexInicial = 0) {
        _listaImagens = [];

        this.setState({
            listaImagens: [],
            activeIndex: indexInicial,
            valueInputThumb: indexInicial + 1,
            carregandoFrames: true
        });

        let order = 0;
        let listaImagensTemp = [];

        const studyUID = this.props.selectedPedido.StudyUid;
        const seriesUID = instances.Serie;

        const loadImageBlob = async (url) => {
            const response = await axios.get(url, { responseType: 'arraybuffer' });
            const blob = new Blob([response.data], { type: 'image/jpeg' });
            return URL.createObjectURL(blob);
        };

        const preloadImage = (url) => {
            return new Promise((resolve) => {
                const img = new Image();
                img.onload = () => resolve(url);
                img.onerror = () => resolve(null);
                img.src = url;
            });
        };

        const allPromises = [];

        for (const instance of instances.Instances) {
            const numFrames = await this.getNumeroDeFramesFromMetadata(studyUID, seriesUID, instance);

            for (let j = 0; j < numFrames; j++) {
                const url = `${this.props.servicoImagem}/${studyUID}/series/${seriesUID}/instances/${instance}/frames/${j}/rendered/512/512`;

                const ordemAtual = order++;
                const promise = loadImageBlob(url)
                    .then(preloadImage)
                    .then((imageUrl) => {
                        if (imageUrl) {
                            listaImagensTemp.push({
                                label: imageUrl,
                                order: ordemAtual,
                                Serie: seriesUID,
                                Instance: instance
                            });
                        }
                    })
                    .catch((err) => {
                        console.error("Erro ao carregar/preload da imagem:", err);
                    });

                allPromises.push(promise);
            }
        }

        await Promise.all(allPromises);

        const listaOrdenada = listaImagensTemp.sort((a, b) => a.order - b.order);

        this.setState({
            listaImagens: listaOrdenada,
            activeIndex: indexInicial,
            valueInputThumb: indexInicial + 1,
            selectImageView: listaOrdenada[indexInicial]?.label || listaOrdenada[0]?.label,
            totalImagens: listaOrdenada.length,
            carregandoFrames: false
        });

        document.getElementById("progressSpinner").style.display = "none";
        this.thumbMouseMove();
    }




    calcBrilhoImagem() {
        return this.state.brilhoImageValue / 500;
    }

itemTemplate(item, width) {
    try {
        let imagens = this.getImagensAtuais();
        let image = item ? item : imagens[0];
        if (!image) return null;
        let src = image.label ? image.label : (image.ImageBase64 ? `data:image/jpeg;base64,${image.ImageBase64}` : '');
        return (
            <div
                className="GaleryImage"
                onWheel={(e) => this.handleWheelThumb(e, imagens.length)}
            >
                <img
                    src={src}
                    id={`imgView${this.state.activeIndex}`}
                    className="galeria-imagem"
                    onClick={this.toggleFooter}
                    style={{
                        filter: `brightness(${this.calcBrilhoImagem()})`,
                        width: '100%',
                        height: 'auto'
                    }}
                />
            </div>
        );
    } catch (error) {
        console.log(error);
    }
}

    thumbnailTemplate(item) {
        return <img src={item.label} id={md5(item.label)} style={{ display: 'block' }} height="40" />;
    }

    onItemChange(event) {
        this.setState({ activeIndex: event.index, valueInputThumb: event.index + 1 });
    }
    onItemChangeThumb(index) {
        this.setState({ activeIndex: index, valueInputThumb: index + 1 });
    }

    handleKeyPress = (e) => {
        if (e.key == 'Enter') {
            this.onItemChangeThumb(e.target.value - 1)
        }
    }

    handleWheelThumb = (e, totalImagens) => {
        if (Math.abs(e.deltaY) < 10) return; // ignora scroll muito fraco

        const { activeIndex } = this.state;

        if (!totalImagens || totalImagens <= 1) return;

        const maxIndex = totalImagens - 1;

        e.preventDefault();

        if (e.deltaY > 0 && activeIndex < maxIndex) {
            this.onItemChangeThumb(activeIndex + 1);
        } else if (e.deltaY < 0 && activeIndex > 0) {
            this.onItemChangeThumb(activeIndex - 1);
        }
    };




    toggleFooter = () => {
        this.setState((prevState) => ({
            footerVisible: !prevState.footerVisible
        }));
    };

    renderFooter() {
        const { activeIndex, footerVisible } = this.state;
        const listaImagens = this.getImagensAtuais();

        return (
            <div
                className={`custom-galleria-footer ${footerVisible ? 'show-footer' : 'hide-footer'}`}
                style={{ transition: 'max-height 0.5s ease, opacity 0.5s ease', overflow: 'hidden' }}
            >
                <div>
                    {/* Slider de brilho horizontal */}
                    {listaImagens.length > 1 && (
                        <div className="GaleriaSliderArea">
                            <label>
                                Brilho da imagem ({Math.round((this.state.brilhoImageValue / 1000) * 100)}%)
                            </label>

                            <div className="footer-slider-wrapper">
                                <span style={{ textAlign: 'center' }}>-</span>
                                <Slider
                                    className="GaleriaBrightSlider"
                                    value={this.state.brilhoImageValue}
                                    min={0}
                                    max={1000}
                                    step={10}
                                    onChange={(e) => this.setState({ brilhoImageValue: e.value })}
                                />
                                <span style={{ textAlign: 'center' }}>+</span>
                            </div>
                        </div>
                    )}

                    {listaImagens.length == 1 && (
                        <div className="GaleriaSliderAreaSingleImage">
                            <label>
                                Brilho da imagem ({Math.round((this.state.brilhoImageValue / 1000) * 100)}%)
                            </label>

                            <div className="footer-slider-wrapper">
                                <span style={{ textAlign: 'center' }}>-</span>
                                <Slider
                                    className="GaleriaBrightSlider"
                                    value={this.state.brilhoImageValue}
                                    min={0}
                                    max={1000}
                                    step={10}
                                    onChange={(e) => this.setState({ brilhoImageValue: e.value })}
                                />
                                <span style={{ textAlign: 'center' }}>+</span>
                            </div>
                        </div>
                    )}
                </div>

                <div className="GaleriaButtonsArea">

                    <div className="GaleriaButtons">
                        {listaImagens.length > 1 && (
                            <Button
                                icon="pi pi-chevron-left"
                                className="GaleriaBtnFooterLeft"
                                style={{ marginRight: '5px', top: '4px' }}
                                onClick={() => this.onItemChangeThumb(
                                    activeIndex > 0 ? activeIndex - 1 : 0
                                )}
                            />
                        )}

                        {listaImagens.length > 1 && (
                            <input
                                className="GaleriaInputFooter"
                                value={`${this.state.valueInputThumb} / ${listaImagens.length}`}
                                onKeyPress={(e) => this.handleKeyPress(e, true)}
                                onChange={(e) => this.setState({ valueInputThumb: e.target.value })}
                                type="text"
                            />
                        )}

                        {listaImagens.length > 1 && (
                            <Button
                                icon="pi pi-chevron-right"
                                className="GaleriaBtnFooterRight"
                                style={{ marginLeft: '5px', top: '4px' }}
                                onClick={() => this.onItemChangeThumb(
                                    activeIndex < listaImagens.length - 1
                                        ? activeIndex + 1
                                        : activeIndex
                                )}
                            />
                        )}

                    </div> 
                </div>

                <div>
                    {/* Scrollbar horizontal - s� aparece com mais de uma imagem */}
                    {listaImagens.length > 1 && (
                        <div className="GaleriaScrollbarArea">
                            <input
                                type="range"
                                min={0}
                                max={listaImagens.length - 1}
                                value={activeIndex}
                                className="GaleriaScrollbar"
                                onChange={(e) => this.onItemChangeThumb(Number(e.target.value))}
                            />
                        </div>
                    )}

                </div>
            </div>
        );
    }


    adicionaImagemAoLayout(obj) {
        if (obj.Index < this.state.listaImagens.length)
            try {
                return obj.Pdf.addImage(this.state.listaImagens[obj.Index].label, 'jpg', obj.X, obj.Y, 96, 80);
            } catch (error) { }
        return "";
    }

    _getUrl() {
        return axios
            .get("config.json")
            .then(res => res.data.servico)
            .then(url => {
                if (url[url.length - 1] === "/") return url;
                return url + "/";
            });
    };

    // abortarRequisicao() {
    //     xhr.abort();
    // }

    async imprimirImagens() {
        const { exibindoJobs, jobSelecionado } = this.state;
        const isMobile = this.props.mobilecheck();

        // Se estiver exibindo jobs, use PrintJobId
        if (exibindoJobs && jobSelecionado) {
            this.setState({ carregandoJobs: true });
            const progress = document.getElementById("progressSpinner");
            if(progress){
                progress.style.display = "flex";
            }
            let intervalo;
            try {
                this.setState({ carregandoJobs: true });
                intervalo = setInterval(async () => {
                    try {
                        const progress = await GetProgress(jobSelecionado.Id);
                        if (progress.data.progress !== undefined) {
                            this.setState({ progressoJob: progress.data.progress });
                        }
                    } catch (error) {
                        // Silencie erro de progresso
                    }
                }, 3000);

                const response = await PrintJobId(jobSelecionado.Id);

                if (isMobile) {
                    const nameFile = uuidv4();
                    const file = new File([response.data], nameFile, { type: "application/pdf" });
                    const pdfUrl = URL.createObjectURL(file);
                    var fileLink = document.createElement('a');
                    fileLink.href = pdfUrl;
                    fileLink.download = nameFile;
                    fileLink.click();
                } else {
                    const blob = new Blob([response.data], { type: 'application/pdf' });
                    const pdfUrl = URL.createObjectURL(blob);
                    window.open(pdfUrl);
                }
            } catch (error) {
                // Trate erro se necessário
            }
            finally {
                clearInterval(intervalo);
                this.setState({ carregandoJobs: false, progressoJob: 0 });

                const progress = document.getElementById("progressSpinner");
                if(progress){
                    progress.style.display = "none";
                }

            }
            return;
        }

        // ...código original do imprimirImagens para imagens normais...
        // ...existing code...
        xhr = new XMLHttpRequest();

        document.getElementById("progressSpinner").style.display = "flex";

        let imagensDTO = [];
        let Layout = this.props.selectedPedido.Modalidade.LayoutPortal != null ? this.props.selectedPedido.Modalidade.LayoutPortal : 6;

        let order = 0;

        if (this.state.listaImagensThumb) {
            this.state.listaImagens.forEach((img, index) => {
                const listaImagensThumb = this.state.listaImagensThumb.filter(obj => obj.instances.Serie === img.Serie);
                imagensDTO.push({
                    StudyUid: this.props.selectedPedido.StudyUid,
                    Serie: img.Serie,
                    Instance: listaImagensThumb[0].instances.Instances[index],
                    Order: order++,
                    Layout: Layout,
                });
            });
        }

        const pedidoImagem = {
            PedidoId: this.props.selectedPedido.Id,
            StudyUid: this.props.selectedPedido.StudyUid,
            Imagens: imagensDTO
        }

        const mobileCheck = this.props.mobilecheck();

        this._getUrl().then(url => {
            let caminho = `${url}api/Pedido/PostVisualizarLayoutImagem`;
            xhr.open('POST', caminho, true);

            xhr.responseType = 'arraybuffer';

            xhr.setRequestHeader('user', `${ServiceApi._getHeaders().headers.user}`);
            xhr.setRequestHeader('Cnonce', `${ServiceApi._getHeaders().headers.Cnonce}`);
            xhr.setRequestHeader('Token', `${ServiceApi._getHeaders().headers.Token}`);
            xhr.setRequestHeader('TokenPortal', `${ServiceApi._getHeaders().headers.TokenPortal}`);
            xhr.setRequestHeader('isPacientePortal', `${ServiceApi._getHeaders().headers.isPacientePortal}`);
            xhr.setRequestHeader('isConvenioPortal', `${ServiceApi._getHeaders().headers.isConvenioPortal}`);
            xhr.setRequestHeader('Content-type', 'application/json; charset=utf-8');

            xhr.onload = function (e) {
                if (this.status == 200) {
                    if (mobileCheck) {
                        var file = new File([this.response], uuidv4(), { type: "application/pdf" });
                        var exportUrl = URL.createObjectURL(file);
                        var fileLink = document.createElement('a');
                        fileLink.href = exportUrl;
                        fileLink.download = uuidv4();
                        fileLink.click();
                        document.getElementById("progressSpinner").style.display = "none";
                    } else {
                        var blob = new Blob([this.response], { type: "application/pdf" });
                        var pdfUrl = URL.createObjectURL(blob);
                        print(pdfUrl);
                        document.getElementById("progressSpinner").style.display = "none";
                    }
                }
            };

            let jsonData = JSON.stringify(pedidoImagem);

            xhr.send(jsonData);

        });

        this.props.adicionarHistoricoAcoes(42, this.props.selectedPedido.Id);
    }

    // ...existing code...
    getImagensAtuais() {
        return this.state.exibindoJobs ? this.state.jobImages : this.state.listaImagens;
    }

    acaoBtnCancelar() {
        if (xhr) xhr.abort();

        // Limpa overflow e poss�veis classes grudadas
        document.body.classList.remove("p-overflow-hidden", "overflow-hidden");
        document.body.style.overflow = "auto";

        this.props.onHideGaleria();
    }

render() {
    if (!this.props.selectedPedido) {
        return <div style={{ color: '#fff', padding: '20px' }}>Nenhum exame selecionado.</div>;
    }

    const { exibindoJobs, possuiJob, listaJobs, jobSelecionado, carregandoJobs, progressoJob } = this.state;
    const semImagens = !possuiJob && this.state.listaImagensThumb.length === 0 && !this.state.carregandoFrames && !this.state.carregandoThumbs;

    if (possuiJob && exibindoJobs) {
        return (
            <div className="GaleriaWrapper">
                <div className="GaleriaGrid">
                    {/* Thumbs dos jobs */}
                    <div className="GaleriaThumbWrapper">

                        <div
                            className="GaleriaThumbList"
                            style={{ height: '100%', overflowY: 'auto' }}
                        >
                            {listaJobs.map((job, idx) => (
                                <img
                                    key={job.Id}
                                    src={job.thumb ? `data:image/jpeg;base64,${job.thumb}` : ''}
                                    alt={`Job ${job.Id}`}
                                    className={`imgThumbSerie ${jobSelecionado?.Id === job.Id ? 'imgThumbSel' : ''}`}
                                    style={{ marginBottom: 10, cursor: 'pointer' }}
                                    onClick={() => this.selecionarJob(job)}
                                />
                            ))}
                        </div>
                    </div>
                    {/* Viewer igual ao modo normal */}
                    <div className="GaleriaViewerWrapper">
                                                {/* --- BOTÃO DE IMPRIMIR --- */}
                        <div className="GaleriaPrintButtonJob">
                            <Button icon="pi pi-print" iconOnly onClick={() => this.imprimirImagens()} style={{
                                backgroundColor: '#161618',
                                maxWidth: '50px',
                                border: 'none',
                                boxShadow: 'none',
                                outline: 'none',
                            }} />
                        </div>
                        {/* Ajuste: Loading e progresso do PDF */}
                        {(carregandoJobs || progressoJob > 0) && (
                            <div className="GaleriaSpinnerOverlay" style={{
                                position: 'absolute',
                                left: 0, top: 0, right: 0, bottom: 0,
                                background: 'rgba(0,0,0,0.6)',
                                zIndex: 20,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <ProgressSpinner />
                                <div style={{ color: '#fff', marginTop: 16 }}>
                                    {progressoJob > 0
                                        ? `Gerando PDF: ${progressoJob}%`
                                        : 'Gerando PDF...'}
                                </div>
                            </div>
                        )}
                        <div id="galleria" className="GaleriaViewer">
                            <Galleria
                                className="GaleriaViewer-content"
                                showItemNavigators
                                value={this.getImagensAtuais()}
                                activeIndex={this.state.activeIndex}
                                responsiveOptions={this.responsiveOptions}
                                item={(e) => this.itemTemplate(e, this.state._autoWidth)}
                                showThumbnails={false}
                                footer={this.renderFooter()}
                                onItemChange={(e) => this.onItemChange(e)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
        // --- FIM ALTERAÇÃO JOB ---

        // ...galeria normal permanece igual...
        const semImagensNormal = this.state.listaImagensThumb.length === 0 && !this.state.carregandoFrames && !this.state.carregandoThumbs;
        return (
            <div className="GaleriaWrapper">
                <div className="GaleriaGrid">
                    {/* Lista lateral de thumbnails */}
                    <div className="GaleriaThumbWrapper">
                        {this.state.mostrarFadeEsquerda && <div className="GaleriaThumbFadeLeft" />}

                        <div
                            id="listaImagensThumb"
                            className="GaleriaThumbList"
                            ref={(el) => { this.thumbListRef = el }}
                            onScroll={this.atualizarFadesThumb}
                        >
                            {this.state.listaImagensThumb.map((srcImg, index) => (
                                <img
                                    key={index}
                                    src={srcImg.label}
                                    className={`imgThumbSerie ${this.state.activeIndexThumb === index ? 'imgThumbSel' : ''}`}
                                    onClick={() => this.listarImagensPorSerie(srcImg.instances)}
                                    draggable={true}
                                    id={`img${index}`}
                                />
                            ))}
                        </div>

                        {this.state.mostrarFadeDireita && <div className="GaleriaThumbFadeRight" />}
                    </div>

                    {/* Viewer + brilho vertical */}
                    <div className="GaleriaViewerWrapper">

                        {/* --- BOTÃO DE IMPRIMIR --- */}
                        <div
                            className="GaleriaPrintButton"
                            style={{ display: this.props.selectedPedido.Tipo === 'externo' ? 'none' : 'block' }}
                        >
                            <Button icon="pi pi-print" iconOnly onClick={() => this.imprimirImagens()} style={{
                                backgroundColor: '#161618',
                                maxWidth: '50px',
                                border: 'none',
                                boxShadow: 'none',
                                outline: 'none',
                            }} />
                        </div>

                        {/* Spinner de carregamento */}
                        <div
                            id="progressSpinner"
                            className="GaleriaSpinner"
                            style={{ display: semImagensNormal ? 'none' : undefined }}
                        >
                            <ProgressSpinner />
                        </div>

                        {semImagensNormal && !this.props.selectedPedido.possuiJob && (
                            <div className="GaleriaNoImage">
                                <i className="pi pi-exclamation-triangle" style={{ fontSize: '4em', color: '#777' }}></i>
                                <div style={{ color: '#fff', marginTop: '10px' }}>Nenhuma imagem encontrada para este estudo.</div>
                            </div>
                        )}

                        {this.state.carregandoFrames && (
                            <div className="GaleriaSpinnerOverlay">
                                <ProgressSpinner />
                                <div style={{ color: '#fff', marginTop: '10px' }}>Carregando imagens...</div>
                            </div>
                        )}

                        <div id="galleria" className="GaleriaViewer">
                            <Galleria
                                className="GaleriaViewer-content"
                                showItemNavigators
                                value={this.getImagensAtuais()}
                                activeIndex={this.state.activeIndex}
                                responsiveOptions={this.responsiveOptions}
                                item={(e) => this.itemTemplate(e, this.state._autoWidth)}
                                showThumbnails={false}
                                footer={this.renderFooter()}
                                onItemChange={(e) => this.onItemChange(e)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}